import { render, staticRenderFns } from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=template&id=45458018&scoped=true&lang=pug"
import script from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=style&index=0&id=45458018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45458018",
  null
  
)

export default component.exports